import React from 'react';
import { LIVE_MARKETPLACES, COMING_MARKETPLACES } from '../../constants/siteMap';

// ---------------------------------------------------------------------------
// Which marketplaces a seller can actually get a file for, and which are on
// the way.
//
// One component, because this claim appeared in four places in slightly
// different words and every one of them named marketplaces the export engine
// refuses. Both lists are derived from ENABLED_MARKETPLACES — the same flag the
// server enforces — so the page cannot promise what the product will decline.
//
// The coming ones are named rather than hidden. They are genuinely built
// (adapters, field maps, templates, imported category metadata) and simply not
// opened to sellers yet, and "coming soon" beside a real date-free label is
// honest in a way that silence is not.
// ---------------------------------------------------------------------------

export default function MarketplaceStatus({ className = '', align = 'center' }) {
  const alignment = align === 'left' ? 'justify-start text-left' : 'justify-center text-center';

  return (
    <div className={className}>
      <div className={`flex flex-wrap items-center gap-2 ${alignment}`}>
        {LIVE_MARKETPLACES.map((m) => (
          <span
            key={m}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-ink
                       border border-green-500/40 bg-green-500/10 px-3.5 py-1.5 rounded-lg"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-green-500" />
            {m}
            <span className="text-[11px] font-medium text-green-600">live</span>
          </span>
        ))}

        {COMING_MARKETPLACES.map((m) => (
          <span
            key={m}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-ink-3
                       border border-line bg-surface px-3.5 py-1.5 rounded-lg"
          >
            {m}
            <span className="text-[11px]">coming soon</span>
          </span>
        ))}
      </div>
    </div>
  );
}

/** The same fact as one line of prose, for places a row of chips would not fit. */
export function marketplaceSentence() {
  const live = LIVE_MARKETPLACES.join(', ');
  if (!COMING_MARKETPLACES.length) return `Files for ${live}.`;
  return `${live} today — ${COMING_MARKETPLACES.join(', ')} coming soon.`;
}
